<script>
    import FeatureTable from "../Misc/WPNFeatureTable.svelte";
    import schemaData from "../../Stores/wpn2SchemaStore.js"
    import { textForKeyData } from "../../scripts/wpn2Model.js";

    export let item;
    let amData;

    $: amData = getAssetManagementInfo(item);

    function getAssetManagementInfo(item) {
        if (['FixedAsset', 'Pipe'].includes(item.entity)) {
            const amAttrs = ["condition", "redundancy", "cof", "priority", "useful_life", "installation_date", "acquisition_date", "replacement_cost"];
            var assetManagementInfo = amAttrs.map((a) => $schemaData.keysList.find((x) => x.key === a));
            assetManagementInfo.forEach(x => x.value = textForKeyData(x, item, "Unknown") ?? "");
            let amInfoOne = assetManagementInfo.slice(0, 4);
            let divider = { key: "divider" };
            let amInfoTwo = assetManagementInfo.slice(4);
            const amInfo = amInfoOne.concat(divider, amInfoTwo);
            const unknownAMData = amInfo.filter(x => x.value == 'Unknown');
            return (unknownAMData.length < 8) ? amInfo : [];
        }
    }
</script>

{#if ['FixedAsset', 'Pipe'].includes(item.entity) && amData.length > 0}
    <div class="detail-section">
        <div class="detail-section-title">Asset Management</div>
        <FeatureTable itemInfo={amData} />
    </div>
{/if}
